<app-simple-modal-header
	[pageTitle]="pageTitle"
	(dismissed)="dismiss()"
	*ngIf="inventoryItem"
>
	<app-inventory-modal-header
		[inventoryItem]="inventoryItem"
	></app-inventory-modal-header>
</app-simple-modal-header>

<ion-content *ngIf="inventoryItem">
	<form [formGroup]="form" *ngIf="form">
		<ion-item-group lines="full">
			<ion-item *ngIf="enableInventoryRemovalReason">
				<ion-label position="stacked" class="bold">
					Removal Reason
				</ion-label>
				<ion-select
					[formControl]="form.controls.removalReason"
					placeholder="Select"
				>
					<ion-select-option
						*ngFor="let reason of removalReasons"
						[value]="reason.id"
					>
						{{ reason.description }}
					</ion-select-option>
					<ion-select-option [value]="-1">Other</ion-select-option>
				</ion-select>
			</ion-item>
			<ion-item>
				<ion-label position="stacked" class="bold">
					Removal Status
				</ion-label>
				<ion-select
					[formControl]="form.controls.removalStatus"
					placeholder="Select"
				>
					<ion-select-option
						*ngFor="let status of removalStatusOptions"
						[value]="status.id"
					>
						{{ status.status }}
					</ion-select-option>
				</ion-select>
			</ion-item>
			<ion-item *ngIf="enableInventoryRemovalReason">
				<ion-label position="stacked" class="bold">
					Removal Note
				</ion-label>
				<ion-textarea
					[formControl]="form.controls.removalNote"
					name="note"
					type="text"
					rows="7"
				></ion-textarea>
			</ion-item>
		</ion-item-group>
	</form>
</ion-content>

<ion-footer>
	<ion-button class="modal__submit" (click)="onSwapInventory()">
		Swap Inventory
	</ion-button>	
	<ion-button color="danger" class="modal__submit" (click)="onRemoveInventory()">
		Remove Inventory
	</ion-button>
</ion-footer>
